import { customAlphabet } from "nanoid";

const nanoid = customAlphabet("ABCDEF012345678", 8);

export const gen_id = () => nanoid();
